import {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { BottomSheet } from '@edikk-edikk/bottom-sheet';
import { useBooleanValue } from '@edikk-edikk/hooks';
import { Page } from '@edikk-edikk/country-layout-black';
import {
  StoryDetailListWrapperContext,
  StoryDetailListWrapperContextType,
  StoryDetailListWrapperTitle,
  StoryDetailListWrapperType,
} from '#advertStory/detail-list-wrapper';
import { StoryDetailList, StoryDetailListType } from '#advertStory/detail-list';
import { StoryDetailListTimeline } from '#advertStory/detail-list-timeline';
import storyDetailListWrapperCss from '../assets/detail/story-detail-list-wrapper.module.scss';

const StoryDetailListWrapper = forwardRef<StoryDetailListWrapperType, any>((
  _,
  forwardedRef,
) => {
  const [isVisible, show, hide] = useBooleanValue();
  const refStoryDetailList = useRef<StoryDetailListType>(null);
  const [initialSlide, setInitialSlide] = useState<number>(0);

  const open = useCallback((newInitialSlide: number): void => {
    setInitialSlide(newInitialSlide);
    show();
  }, [show]);

  useImperativeHandle<StoryDetailListWrapperType, StoryDetailListWrapperType>(forwardedRef, () => ({
    open,
  }), [open]);

  const storyDetailListWrapperContextValue: StoryDetailListWrapperContextType = {
    hide,
  };

  return (
    <StoryDetailListWrapperContext value={storyDetailListWrapperContextValue}>
      <BottomSheet
        isVisibleHeader={false}
        isVisible={isVisible}
        show={show}
        hide={hide}
        isFullHeight
        overlayAdditionalClassName="bottom-sheet-overlay_with-blur"
        additionalClassName="bottom-sheet_transparent"
        bodyAdditionalClassName="d-flex"
      >
        <Page withoutPaddingTop withMarginBottom>
          <div className={storyDetailListWrapperCss.storyDetailListWrapper}>
            <StoryDetailListWrapperTitle />
            <StoryDetailListTimeline
              refStoryDetailList={refStoryDetailList}
              additionalClassName={storyDetailListWrapperCss.storyDetailListWrapper__timeline}
            />
            <StoryDetailList
              ref={refStoryDetailList}
              additionalClassName={storyDetailListWrapperCss.storyDetailListWrapper__list}
              initialSlide={initialSlide}
            />
          </div>
        </Page>
      </BottomSheet>
    </StoryDetailListWrapperContext>
  );
});

export { StoryDetailListWrapper };
